

















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import type { EBlockWidth } from '@getaccept/editor-lib';
import type { MappedContentPlaceholder } from '@getaccept/editor-lib/src/types/mapped-content-placeholder';
import { PlaceholderType } from '@getaccept/editor-lib/src/types/enums';
import type { ContentPlaceholder } from '@getaccept/editor-lib/src/types/models';
import EditorNodeWrapper from '../EditorNodeWrapper.vue';
import ResourcePlaceholder from './ResourcePlaceholder.vue';
import ElementPlaceholder from './ElementPlaceholder.vue';

export default defineComponent({
  components: {
    EditorNodeWrapper,
    ResourcePlaceholder,
    ElementPlaceholder,
  },
  props: {
    node: {
      type: Object as PropType<ContentPlaceholder>,
      required: true,
    },
    parentFirstChild: { type: Boolean },
    parentLastChild: { type: Boolean },
    blockWidthClass: { type: String as PropType<EBlockWidth>, default: null },
    rowTypeClass: { type: String, default: null },
    placeholder: {
      type: Object as PropType<MappedContentPlaceholder>,
      default: () => ({}),
    },
  },
  setup(props) {
    const isResourcePlaceholder = computed(
      () => props.node?.placeholder?.type === PlaceholderType.Resource
    );

    return {
      isResourcePlaceholder,
    };
  },
});
